module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"propTitle prop-header hide\"><span class=\"prop-label\">File Attachment Settings</span></div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-12 subsection nopadding-r\">\r\n        <label class=\"prop-sublabel label-60\">Max Size</label> \r\n        <div class=\"col-md-8 input-group spinFileSize\">\r\n            <div class=\"label-75\" style=\"display: flex;\">\r\n                <input type=\"text\" class=\"form-control\" name=\"fileSize\" id=\"fileSize\"  style=\"width:85px;\" value=\"")
    ; __append(escapeFn( fileSize ))
    ; __append("\" />\r\n                <div class=\"input-group-btn-vertical\">\r\n                    <button id=\"btn-up-fSize\" class=\"btn btn-default\" type=\"button\" style=\"height: 12px;\">\r\n                        <span class=\"fa fa-caret-up\"></span>\r\n                    </button>\r\n                    <button id=\"btn-down-fSize\" class=\"btn btn-default\" type=\"button\" style=\"height:12px;\">\r\n                        <span class=\"fa fa-caret-down\"></span>\r\n                    </button>\r\n                </div>\r\n                <div class=\"col-md-1 prop-sublabel\" style=\"margin-left: 15px !important\">\r\n                    Mb\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div> \r\n</div>")
  }
  return __output;

}